export const emojiRegex =
    /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\u2600-\u26FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|\uD83E[\uDD00-\uDDFF])/g;

